import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Divider } from 'primereact/divider';
import { AUTH_APP } from '../../../utils/constants';
import { AuthApiService } from '../../../services/AuthApiService';
import { Tag } from 'primereact/tag';
import { isMobile } from "react-device-detect";

const MFAApp = (props) => {
  const {
    authExpand,
    userId,
    mfaStatus,
    mobileAppIsEnabled,
    id,
    deviceName,
    handleAuthExpand,
    updateDeviceDefault,
    deviceRemoved,
    updateSuccess,
    updateError
  } = props;
  const _apiService = new AuthApiService();

  const [code, setCode] = useState('');
  const [QRImgContent, setQRImgContent] = useState('');
  const [QRCodeContent, setQRCodeContent] = useState('');
  const [requestId, setRequestId] = useState('');
  const [deviceId, setDeviceId] = useState('');

  useEffect(async () => {
    // If mobile app is not enabled, call enroll service when expand
    if (authExpand && !mobileAppIsEnabled) {
      const requestBody = {
        schemas: [
          'urn:ietf:params:scim:schemas:oracle:idcs:AuthenticationFactorEnroller'
        ],
        user: {
          value: userId
        },
        authnFactors: [AUTH_APP],
        isDeviceOffline: true
      };

      // The same service is also used for getting auth app QR content
      const res = await _apiService.postEnrollMobile(requestBody);

      if (!res || res.error) {
        console.error(res.error);
        // toast.current.show({ severity: 'error', summary: res.error, detail: 'Message Content', life: 3000 });
      }
      else {
        const { qrCodeContent, qrCodeImgContent, requestId, deviceId } = res;
        setQRCodeContent(atob(qrCodeContent));
        setQRImgContent(atob(qrCodeImgContent));
        setRequestId(requestId);
        setDeviceId(deviceId);
      }
    }
  }, [authExpand]);

  const validateMobileApp = async () => {
    const data = {
      "schemas": ["urn:ietf:params:scim:schemas:oracle:idcs:AuthenticationFactorValidator"],
      "deviceId": deviceId,
      "requestId": requestId,
      "otpCode": code,
      "authFactor": AUTH_APP,
      "scenario": "ENROLLMENT"
    };

    const res = await _apiService.postValidatePassMobile(data);

    if (!res || res.error) {
      console.error(res.error);
      updateError('Verification code validation failed');
    }
    else {
      updateSuccess('Authenticator app added successful');
    }
  };

  const updateAppDefault = () => {
    updateDeviceDefault(AUTH_APP, id);
  };

  const removeMfaApp = async () => {
    deviceRemoved(id, 'Your authentication app has been removed.');
  };

  return (
    <div className="grid grid-nogutter">
      <div className="edit-cursor" onClick={()=>{
        if(authExpand){
          return
        }
        handleAuthExpand()
      }}>
      <div className={`${authExpand ? 'col-12' : 'col-8 md:col-4'} flex align-items-center justify-content-between`}>
        <p className="font-semibold">AUTHENTICATOR APP {mfaStatus === AUTH_APP && <Tag className="ml-2" severity="success" value="Default MFA"/>}
</p>
      </div>
      <div className={`${authExpand ? 'col-12' : 'col-4'} hidden md:flex align-items-center justify-content-start`}>
        {!authExpand && (
          <>
            <p>
              {mobileAppIsEnabled ? deviceName : 'Verify using Microsoft\'s Authenticator App'}
            </p>
          </>
        )}
      </div>
      </div>
      <div className={`flex align-items-center justify-content-end`}>
        {authExpand ? null : (
          <>
            <Button
              onClick={() => handleAuthExpand()}
              label="Edit"
              className="hidden md:flex p-button-info p-button-text font-semibold"
            />
            <Button
              onClick={() => handleAuthExpand()}
              icon="pi pi-angle-right"
              className="p-button-rounded p-button-info text-4xl p-button-text text-900"
              aria-label="Authenticator"
            />
          </>
        )}
      </div>
      <div className={`col-12 flex md:hidden align-items-center justify-content-start`}>
        {!authExpand && (
          <>
            <p>
              {mobileAppIsEnabled ? deviceName : 'Verify using Microsoft\'s Authenticator App'}
            </p>
          </>
        )}
      </div>
      {authExpand && (
        !mobileAppIsEnabled ? (
          <div className="w-full">
            <div>
              <ol>
                <li className="mb-2">
                  Install <span className="cursor-pointer text-blue-500 underline"><a href="https://www.microsoft.com/en-us/security/mobile-authenticator-app" target="_blank">Microsoft Authenticator</a></span> or
                  use another Authenticator app of your choice.
                </li>
                { isMobile && 
                <li><a href={QRCodeContent}><span class="mb-2">Tap to enroll your phone.</span></a></li>
                }
                {!isMobile && (
                  <>
                  <li className="mb-2">Open the app, select "Add Account".</li>
                  <li className="mb-2">
                    <div className="flex flex-column">
                      Scan the QR code below.
                      { QRImgContent &&
                        <img
                          className="p-3"
                          width={150}
                          height={150}
                          src={'data:image/png;base64,' + QRImgContent}
                          alt="qr"
                        />
                      }
                    </div>
                  </li>
                  <li>Enter the 6-digit verification code generated by your Authenticator App.</li>
                  </>
                )}
              </ol>
            </div>
            <div className="mt-5 w-full flex md:flex-row flex-column align-items-center justify-content-between">
              <div className="field flex flex-column">
                <label htmlFor="phone">Verification Code</label>
                <InputMask
                  value={code}
                  type='tel'
                  placeholder="Enter Code"
                  mask="999999"
                  slotChar=''
                  onChange={(e) => setCode(e.value)}
                />
              </div>
              <div>
                <Button onClick={() => handleAuthExpand()} label="Cancel" className="p-button-info p-button-text"/>
                <Button onClick={() => validateMobileApp()} label="Save" className="p-button-info ml-3"/>
              </div>
            </div>
          </div>) : (
          <div className="w-full">
            <div className="my-2">
              {deviceName}
            </div>
            <div className="my-2">
              {mfaStatus !== AUTH_APP &&
              <>
                <div>
                  <Button onClick={() => updateAppDefault()} label="Set as default verification method"
                          className="p-button-info p-button-text font-bold px-0"/>
                </div>
                <div>
                  <Button onClick={() => removeMfaApp()} label="Remove"
                          className="p-button-info p-button-text font-bold px-0"/>
                </div>
              </>
              }
            </div>
            <div className="flex justify-content-end">
              <Button onClick={() => handleAuthExpand()} label="Cancel" className="p-button-info p-button-text"/>
            </div>
          </div>
        )
      )}
      <Divider/>
    </div>
  );
};

export default MFAApp;
